import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {environment} from '@env/environment';
import {Title} from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class PageTitleService {

    public pageTitle$: Observable<string>;
    private _pageTitle: Subject<string>;
    private pageTitle = '';

    constructor(private readonly title: Title) {
        this._pageTitle = new Subject<string>();
        this.pageTitle$ = this._pageTitle.asObservable();
    }

    setTitle(pageTitle: string, defaultSetTitle = false): string {
        // Fix for Data Browsing
        if (!defaultSetTitle || (this.pageTitle !== pageTitle)) {
            this.pageTitle = pageTitle;
            this._pageTitle.next(this.pageTitle);

            const fullPageTitle = this.getFullPageTitle(this.pageTitle);
            this.title.setTitle(fullPageTitle);
        }

        return this.pageTitle;
    }

    setSubTitle(pageSubTitle: string): string {
        const title = this.getTitle();
        const pageTitle = pageSubTitle ? `${pageSubTitle} - ${title}` : title;
        this._pageTitle.next(pageTitle);

        const fullPageTitle = this.getFullPageTitle(pageTitle);
        this.title.setTitle(fullPageTitle);
        return pageTitle;
    }

    unsetSubTitle(): string {
        return this.setTitle(this.pageTitle);
    }

   getTitle(): string {
        return this.pageTitle;
    }

    getFullPageTitle(pageTitle: string): string {
        let fullPageTitle: string = (pageTitle || '');
        if (fullPageTitle) {
            fullPageTitle += ' - ';
        }
        return (fullPageTitle + environment.customer.appTitle);
    }
}
